<template lang='pug'>
v-main
  v-container(fluid)
    v-flex
      v-card
        v-toolbar
          v-toolbar-title
            h3(style="font-weight: 400") My Profile
          template(v-slot:extension, v-if="bisnis_units.length > 0")
            v-tabs(v-model="model", :slider-color="colorTheme" :color="colorTheme")
              v-tab(href="#tab-1") Data User

              v-tab(href="#tab-2") Data Business Unit

        v-tabs-items(v-model="model")
          v-tab-item(value="tab-1")
            v-form(ref="form", v-model="valid", lazy-validation)
              v-card(flat)
                v-card-text.p-5
                  v-row(no-gutters)
                    v-col(cols="3") 
                      v-subheader(color="black") 
                        span(style="color: #D42A2A;") *
                        | &nbsp;Name&nbsp;
                        span(style="font-size:.7rem; color: #909090") (Required)
                    v-col(cols="5")
                      v-text-field(
                        v-model="users.full_name",
                        label="Name",
                        :rules="[rules.required]"
                      )

                  v-row(no-gutters)
                    v-col(cols="3") 
                      v-subheader(style="height: 16px;") 
                        span(style="color: #D42A2A;") *
                        | &nbsp;Email&nbsp;
                        span(style="font-size:.7rem; color: #909090") (Required)
                      small(style="color: #F08703;" class="ml-4") *Email account credential login
                    v-col(cols="5")
                      v-text-field(
                        v-model="users.email",
                        label="Email",
                        type="email",
                        disabled
                      )

                  //- v-row(no-gutters v-if="$store.state.dataUsers.role == 'super_user'")
                  //-   v-col(cols="3") 
                  //-     v-subheader Phone Number
                  //-   v-col(cols="5")
                  //-     v-text-field(
                  //-       v-model="users.msisdn",
                  //-       label="Phone Number",
                  //-       :rules="[rules.required, rules.number, rules.msisdn]",
                  //-       @keypress="isNumber($event)"
                  //-     )

                  v-row(no-gutters)
                    v-col(cols="3") 
                      v-subheader 
                        | &nbsp;Old Password&nbsp;
                    v-col(cols="5")
                      v-text-field.input-group--focused(
                        :append-icon="show1 ? 'visibility' : 'visibility_off'",
                        :type="show1 ? 'text' : 'password'",
                        v-model="users.old_password",
                        label="Old Password",
                        @click:append="show1 = !show1"
                        @keyup="checkPass"
                      )

                  v-row(no-gutters)
                    v-col(cols="3") 
                      v-subheader 
                        | &nbsp;New Password&nbsp;
                    v-col(cols="5")
                      v-text-field.input-group--focused(
                        :append-icon="show2 ? 'visibility' : 'visibility_off'",
                        :rules="passwordRules",
                        :type="show2 ? 'text' : 'password'",
                        v-model="users.new_password",
                        label="New Password",
                        @click:append="show2 = !show2"
                        @keyup="checkPass"
                      )

                  v-row(no-gutters)
                    v-col(cols="3") 
                      v-subheader 
                        | &nbsp;Confirm Password&nbsp;
                    v-col(cols="5")
                      v-text-field.input-group--focused(
                        :append-icon="show3 ? 'visibility' : 'visibility_off'",
                        :rules="confirmPasswordRules",
                        :type="show3 ? 'text' : 'password'",
                        v-model="users.confirm_password",
                        label="Confirm New Password ",
                        @click:append="show3 = !show3"
                        @keyup="checkPass"
                      )

                v-card-actions.my-8
                  v-btn.custom__padding-btn(@click="$router.push('/users')") Back

                  v-btn.custom__padding-btn(
                    color="blue-secondary",
                    :disabled="isChangePasswordValidation || compareChange",
                    @click="update()"
                  ) Update

          v-tab-item(value="tab-2")
            v-card(flat)
              v-card-text.p-5
                v-row(no-gutters)
                  v-col(cols="3") 
                    v-subheader Business unit 
                  v-col(cols="5")
                    v-autocomplete(
                      ref="bu.bisnis_unit",
                      v-model="bu.bisnis_unit",
                      :rules="[() => !!bu.bisnis_unit || 'This field is required']",
                      :items="bisnis_units",
                      item-text="business_unit.bu_name",
                      item-value="id",
                      label="Business Unit",
                      placeholder="Select",
                      @change="onBU(bu.bisnis_unit.id)",
                      required
                      return-object
                    )

                v-row(no-gutters)
                  v-col(cols="3") 
                    v-subheader(color="black") 
                      span(style="color: #D42A2A;") *
                      | &nbsp;Alias Name&nbsp;
                      span(style="font-size:.7rem; color: #909090") (Required)
                  v-col(cols="5")
                    v-text-field(
                      v-model="bu.alias",
                      label="Alias Name",
                      :rules="[rules.required]"
                    )

                v-row(no-gutters)
                  v-col(cols="3") 
                    v-subheader(style="height: 16px;") 
                      span(style="color: #D42A2A;") *
                      | &nbsp;Email&nbsp;
                      span(style="font-size:.7rem; color: #909090") (Required)
                    small(style="color: #F08703;" class="ml-4") *Email for notification memo
                  v-col(cols="5")
                    v-text-field(
                      v-model="bu.email",
                      label="Email (Don't use personal e-mail)",
                      type="email",
                      :rules="[rules.required, rules.email]"
                    )

                v-row(no-gutters)
                  v-col(cols="3") 
                    v-subheader 
                      span(style="color: #D42A2A;") *
                      | &nbsp;Position&nbsp;
                      span(style="font-size:.7rem; color: #909090") (Required)
                  v-col(cols="5")
                    v-text-field(
                      v-model="bu.position",
                      label="Position",
                      type="text",
                      :rules="[rules.required]"
                    )

                v-row(no-gutters)
                  v-col(cols="3") 
                    v-subheader(style="height: 16px;") 
                      | &nbsp;Phone Number&nbsp;
                      span(style="font-size:.7rem; color: #909090") (Optional)
                    small(style="color: #F08703;" class="ml-4") *Phone number for notification memo
                  v-col(cols="5")
                    vue-tel-input(
                      @validate="telValidate" 
                      v-model="bu.msisdn"
                      style="border-top: none; box-shadow: none; border-right: none; border-left: none; border-bottom: 2px solid;"
                    )
                    p(style="color: #ff5252; margin: 0; font-size: 12px;" v-if="bu.msisdn.length > 0 && !validNumber") invalid Phone Number Format


                v-row(no-gutters)
                  v-col(cols="3") 
                    v-subheader Default Business Unit
                  v-col(cols="5")
                    v-checkbox(
                      v-model="bu.default_bu"
                      label="Default"
                    )

              v-card-actions.my-8
                v-btn.custom__padding-btn(@click="$router.push('/users')") Back

                v-btn.custom__padding-btn(
                  color="blue-secondary",
                  :disabled="!formBu",
                  @click="updateBU()"
                ) Update

  v-overlay(:value="overlay")
    v-progress-circular(indeterminate, size="64")
</template>
<script>
import { mapGetters, mapState } from "vuex";
import axios from "axios";
export default {
  name: "MyProfile",
  components: {},
  data() {
    return {
      timer: false,
      validNumber:  false,
      valid: true,
      model: "tab-1",
      users: {
        full_name: "",
        email: "",
        msisdn: null,
        old_password: "",
        new_password: "",
        confirm_password: ""
      },
      temp_users: {
        full_name: "",
        msisdn: ""
      },
      bu: {
        bisnis_unit: "",
        alias: "",
        email: "",
        position: "",
        msisdn: "",
        default_bu: false,
        default_bu_id: null,
        is_active: true,
        is_admin: false
      },
      bisnis_units: [],
      rules: {
        required: (value) => !!value || "The field is required",
        number: (v) => /^\d+$/.test(v) || "Must start 08 or 62",
        msisdn: (value) =>
          (value && value.length >= 10) ||
          "Mobile number cannot be less than 10",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid email format";
        },
      },
      passwordRules: [
        (value) => value.length >= 8 || "Minimum 8 characters",
        (value) => value && /\d/.test(value) || "There must be a numeric character",
        (value) => value && /[A-Z]{1}/.test(value) || "At least 1 uppercase letter",
        (value) => value && /[a-z]{1}/.test(value) || "At least 1 lowercase letter",
        (value) => value && /[^A-Za-z0-9]/.test(value) || "At least one special character",
      ],
      confirmPasswordRules: [
        (value) => !!value || "Please confirm your password",
        (value) => this.users.new_password === value || "Confirm password does not match",
      ],
      dataUser: null,
      overlay: false,
      bu_id: "",
      user_id: "",
      show1: false,
      show2: false,
      show3: false,
      business_unit_id: null
    };
  },
  async mounted() {
    await this.getUserData();
  },
  computed: {
    ...mapState(["API_URL", "WE_URL", "dataUsers"]),
    formUsers() {
      return this.users.full_name && this.users.email;
    },
    compareChange() {
      if (this.temp_users.full_name === this.users.full_name && this.users.old_password === ""&& this.users.new_password === ""&& this.users.confirm_password === "") return true
      return false
    },
    isChangePasswordValidation() {
      // UPDATE PROFILE WITHOUT PASSWORD
      if (
        !this.users.old_password &&
        !this.users.new_password &&
        !this.users.confirm_password
      )
        return false;
      // UPDATE PROFILE WITH PASSWORD
      else if (
        this.users.old_password &&
        /\d/.test(this.users.new_password) &&
        /[A-Z]{1}/.test(this.users.new_password) &&
        /[^A-Za-z0-9]/.test(this.users.new_password) &&
        /\d/.test(this.users.confirm_password) &&
        /[A-Z]{1}/.test(this.users.confirm_password) &&
        /[a-z]{1}/.test(this.users.confirm_password) &&
        /[^A-Za-z0-9]/.test(this.users.confirm_password) &&
        this.users.new_password === this.users.confirm_password
      )
        return false;
      return true;
    },
    formBu() {
      return (
        (this.validNumber || this.bu.msisdn.length == 0) &&
        this.bu.alias &&
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.bu.email) &&
        this.bu.position
      );
    },
    colorTheme() {
      return this.$store.getters.getThemeColor
    }
  },
  methods: {
    telValidate(telnumber) {  
      if (telnumber.valid || this.bu.msisdn.length == 0) this.validNumber = true  
      else  this.validNumber = false
    },
    async getUserData() {
      this.overlay = true;
      let token = localStorage.getItem("token");
      return new Promise((resolve) => {
        axios
          .get(process.env.VUE_APP_API + `/users/info`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((res) => {
            this.overlay = false;
            this.users.full_name = res.data.data.user.full_name;
            this.users.email = res.data.data.user.email;
            // this.users.msisdn = res.data.data.user.msisdn;
            this.bisnis_units =
              res.data.data.user.bu.length > 0 ? res.data.data.user.bu.filter((el) => el.is_active) : "";
            this.user_id = res.data.data.user._id;
            this.temp_users.full_name = res.data.data.user.full_name;
            //- this.temp_users.msisdn = res.data.data.user.msisdn;
            this.business_unit_id = res.data.data.user.hasOwnProperty('default_bu') ? res.data.data.user.default_bu : null

            let dataBU = res.data.data.user.bu;
            if ( res.data.data.user.hasOwnProperty('default_bu') ) {
              dataBU.forEach((item) => {
                if ( res.data.data.user.default_bu == item.business_unit.id ) {
                  this.bu.bisnis_unit = item;
                }
              });
            } else {
              this.bu.bisnis_unit = dataBU[0]
            }
            this.onBU(this.bu.bisnis_unit.id)
            resolve(res);
          })
          .catch((err) => {
            if (err.response.status == 401 || err.response.status == 403) {
              return this.$router.push("/logout");
            }
            this.overlay = false;
            this.$toasted.error(err, { icon: "error" });
          })
          .finally(() => {
            this.overlay = false;
            this.loading = false;
          });
      })
    },
    onBU(item) {
      
      if (item) {
        this.overlay = true;
        this.bu_id = item;
        let token = localStorage.getItem("token");
        axios
          .get(process.env.VUE_APP_API + `/users/admin/${item}`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((res) => {
            this.overlay = false;
            this.bu.alias = res.data.data.alias;
            this.bu.email = res.data.data.email;
            this.bu.msisdn = res.data.data.msisdn ? `+${res.data.data.msisdn}` : "";
            this.bu.position = res.data.data.position;
            this.bu.default_bu = res.data.data.default_bu;
            this.bu.is_active = res.data.data.is_active;
            this.bu.is_admin = res.data.data.is_admin;
          })
          .catch((err) => {
            this.overlay = false;
            this.$toasted.error(err, { icon: "error" });
          })
          .finally(() => {
            this.overlay = false;
            this.loading = false;
          });
      } else {
        (this.bu_id = ""), (this.bu.alias = "");
        this.bu.email = "";
        this.bu.msisdn = "";
        this.bu.position = "";
      }
    },
    async updateBU() {
      this.overlay = true;

      if ( this.bu.default_bu ) {
        this.bu.default_bu_id = this.bu.bisnis_unit.business_unit.id
      } else {
        this.bu.default_bu_id = this.business_unit_id
      }

      this.$store
        .dispatch("updateDataBuToUsers", {
          bu: this.bu,
          bu_id: this.bu_id,
          user_id: this.user_id,
        })
        .then(async(res) => {
          this.overlay = false;
          if (this.showDrawer) this.$store.commit("toggleDrawer");
          
          if (res.data.status == 200) {

            if( this.$store.state.dataUsers.user.hasOwnProperty('default_bu') && this.bu.default_bu ) {
              
              this.$store.commit("setDefaultBu", res.data.data.default_bu)
              this.business_unit_id = res.data.data.default_bu
              this.reloadData(res.data.data.default_bu)

            } else if ( res.data.data.default_bu == null ) {

              const result = await this.getUserData();
              this.$store.commit("setDefaultBu", result.data.data.user.default_bu)
              this.business_unit_id = result.data.data.user.default_bu
              this.reloadData(result.data.data.user.default_bu)

            }

            this.$toasted.success(
              "Success, Business unit data has been successfully updated",
              { icon: "check_circle" }
            );

            setTimeout(function(){
                window.location.reload();
            }, 500);

          } else {
            this.$toasted.error("Failed to Update Data", { icon: "error" });
          }
        })
        .catch((err) => {
          this.overlay = false;
          this.$toasted.error(err.response.data.error, { icon: "error" });
        });
    },
    update() {

      if (this.users.old_password !== "" && this.users.confirm_password !== "" &&
        ( this.users.old_password === this.users.confirm_password || this.users.old_password === this.users.new_password )
      )
        return this.$toasted.error(
          "The old password and the new password cannot be the same",
          { icon: "error" }
        );
      if (this.users.old_password) {
        if (
          !this.users.new_password ||
          !this.users.confirm_password ||
          this.users.new_password !== this.users.confirm_password
        ) {
          this.$toasted.error("Failed to Update Data", { icon: "error" });
          return;
        }
      } else if (
        !this.users.old_password &&
        (this.users.new_password || this.users.confirm_password)
      ) {
        this.$toasted.error("Failed to Update Data", { icon: "error" });
        return;
      }

      this.overlay = true;
      this.$store
        .dispatch("updateDataUsers", {
          users: this.users,
          user_id: this.user_id,
        })
        .then((res) => {
          this.overlay = false;
          if (this.showDrawer) this.$store.commit("toggleDrawer");
          if (res.data.status == 200) {
            this.$toasted.success(
              "Success, the account was successfully updated",
              { icon: "check_circle" }
            );
            setTimeout(function(){
                window.location.reload();
            }, 500);
          } else {
            this.$toasted.error("Failed to Update Data", { icon: "error" });
          }
        })
        .catch((err) => {
          this.overlay = false;
          this.$toasted.error(err.response.data.error, { icon: "error" });
        });
    },
    isNumber(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[0-9]+$/.test(char)) return true;
      else e.preventDefault();
    },
    reloadData(buId) {
      this.$store.dispatch("fetchPreviewConfig", { bu_id: buId });
    },
    checkPass() {
      if (!this.isChangePasswordValidation && !this.compareChange) this.confirmPasswordRules = [true];
      else if (this.users.confirm_password.length == 0) this.confirmPasswordRules = ['Please confirm your password'];
      else if (this.users.confirm_password != this.users.new_password) this.confirmPasswordRules = ['Confirm password does not match'];
      else this.confirmPasswordRules = [
        () => !!this.users.confirm_password || "Please confirm your password",
        () =>  this.users.new_password === this.users.confirm_password || "Confirm password does not match"
      ];
    },
  },
};
</script>

<style>
.v-tabs-bar__content {
  background: #f5f5f5;
}
</style>
